import {
  allInsightsAllowedFilters,
  insightsAllowedFilters,
  salesInsightsAllowedFilters,
  benchmarksAllowedFilters,
  explorerAllowedFilters,
  demographicsAllowedFilters,
  addBenchmarksSpecialFilters,
} from '../../services/dashboard/filtersService';

const state = {
  dashboardSelections: {
    filters: undefined,
  },
  allowedFilters: {
    allInsights: undefined,
    benchmarks: undefined,
    demographics: undefined,
    explorer: undefined,
    insights: undefined,
    salesInsights: undefined,
  },
};


const mutations = {
  updateDashboardSelectedFilters(state, filters) {
    state.dashboardSelections.filters = filters;
  },
  updateAllInsightsAllowedFilters(state, filters) {
    state.allowedFilters.allInsights = filters;
  },
  updateBenchmarksAllowedFilters(state, filters) {
    state.allowedFilters.benchmarks = filters;
  },
  updateDemographicsAllowedFilters(state, filters) {
    state.allowedFilters.demographics = filters;
  },
  updateExplorerAllowedFilters(state, filters) {
    state.allowedFilters.explorer = filters;
  },
  updateInsightsAllowedFilters(state, filters) {
    state.allowedFilters.insights = filters;
  },
  updateSalesInsightsAllowedFilters(state, filters) {
    state.allowedFilters.salesInsights = filters;
  },
};

const actions = {
  setAllowedFilters({ commit }) {
    commit('updateAllInsightsAllowedFilters', allInsightsAllowedFilters());
    commit('updateBenchmarksAllowedFilters', benchmarksAllowedFilters());
    commit('updateDemographicsAllowedFilters', demographicsAllowedFilters());
    commit('updateExplorerAllowedFilters', explorerAllowedFilters());
    commit('updateInsightsAllowedFilters', insightsAllowedFilters());
    commit('updateSalesInsightsAllowedFilters', salesInsightsAllowedFilters());
    commit('updateDashboardSelectedFilters', addBenchmarksSpecialFilters());
  },
  setDashboardSelectedFilters({ commit }, baseFilters) {
    commit('updateDashboardSelectedFilters', addBenchmarksSpecialFilters(baseFilters));
  },
};

export const moduleFilters = {
  state,
  mutations,
  actions,
};
